'use client';

import React, { useEffect } from 'react';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import useAppDispatch from '@/app/hooks/useAppDispatch';
import LoginBar from '@/components/LoginBar/LoginBar';
import UserBar from '@/components/UserBar/UserBar';
import Nav from '@/components/Nav/Nav';
import styles from './AppHeader.module.scss';
import { RootState } from '@/store';
import Image from 'next/image';
import { getCounts } from '@/store/commCenterSlice';

const AppHeader: React.FC = () => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useSelector((state: RootState) => state.user.isAuthenticated);
  const user = useSelector((state: RootState) => state.user.user);

  useEffect(() => {

    if(isAuthenticated && user ) {
      dispatch(getCounts()); // Pass the required argument, e.g., user.id
    }
  }, [isAuthenticated]);


  return (
    <header className={styles.header}>
          {/* Brand Logo */}
          <div className={"container d-flex justify-between font-bold pt-2" }>
              <Link  href="/" passHref>
                <Image
                  src="/Images/logo-uhc-wht.png" // Ensure this path is correct
                  alt="UnitedHealthcare Logo"
                  width={244} // Set the width of the image
                  height={38} // Set the height of the image
                  priority // Ensures the image is loaded immediately

                />
              </Link>
              <Nav isAuthenticated={isAuthenticated} />
              <div className={styles.userWrapper}>
                  {isAuthenticated && user ? <UserBar user={user} /> : <LoginBar />}
               </div>
          </div>
    </header>
  );
};

export default AppHeader;
